"use strict";

module.exports = require('./loader')(window, loadImplementation);
/**
 * Browser specific loadImplementation.  Always uses `window.Promise`
 *
 * To register a custom implementation, must register with `Promise` option.
 */

function loadImplementation() {
  if (typeof window.Promise === 'undefined') {
    throw new Error("any-promise browser requires a polyfill or explicit registration" + " e.g: require('any-promise/register/bluebird')");
  }

  return {
    Promise: window.Promise,
    implementation: 'window.Promise'
  };
}